import { FC, SVGProps } from 'react';

export const KeyIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23.8535 4.74955C23.5406 4.4782 23.0669 4.51192 22.7955 4.82487L14.3042 14.6179C13.1193 13.8058 11.6617 13.374 10.1175 13.4839C6.48996 13.7422 3.75865 16.8922 4.01691 20.5197C4.27516 24.1472 7.42519 26.8785 11.0527 26.6203C14.6802 26.362 17.4115 23.212 17.1532 19.5845C17.0433 18.0403 16.4093 16.6585 15.4376 15.6006L20.4889 9.77478L23.3229 12.232C23.6358 12.5034 24.1095 12.4696 24.3809 12.1567C24.6522 11.8437 24.6185 11.3701 24.3055 11.0987L21.4716 8.64147L23.4375 6.37419L26.2714 8.83142C26.5844 9.10278 27.0581 9.06905 27.3294 8.7561C27.6008 8.44315 27.5671 7.96947 27.2541 7.69812L23.8535 4.74955ZM5.51312 20.4132C5.31369 17.612 7.42281 15.1796 10.224 14.9802C13.0251 14.7807 15.4576 16.8898 15.657 19.691C15.8565 22.4922 13.7473 24.9246 10.9462 25.1241C8.14501 25.3235 5.71255 23.2144 5.51312 20.4132Z"
			fill="currentColor"
		/>
	</svg>
);
